import { Parameter$getCoordinatesSearchV2 } from '~/api/gen'
import { Key } from './fetchSearchCoordinates'

export const getSearchCoordinatesKey = (
  parameter: Parameter$getCoordinatesSearchV2
): Key => {
  return ['searchCoordinates', parameter]
}
